import React from 'react';

import './linkTextComponent.css';
// import RedirectArrow from '../../../../../assets/svgComponents/RedirectArrow';

const LinkTextComponent = ({
  isSubTitleSizeTxt = true,
  linkTxt = 'Learn More',
  linkUrl = '',
}) => {
  const handleLinkClick = () => {
    window.open(linkUrl, '_blank'); //TODOBR: should add default url?
  };

  return (
    <a
      className={`et-v2-link-text-container ${
        !isSubTitleSizeTxt ? 'et-v2-link-text-container-with-large-font ' : ''
      }`}
      onClick={handleLinkClick}
      target="_blank">
      {linkTxt}
      {/* <RedirectArrow /> */}
    </a>
  );
};

export default LinkTextComponent;
